import { LoaderFunction, useFetcher } from "react-router-dom";
import { returnAsset as bridgeReturnAsset } from "../../../../../common/api/bridge/methods.ts";
import { returnAsset as decimalReturnAsset } from "../../../../../common/api/decimal/methods/license.ts";

export interface ReturnResult {
  ok: boolean;
  asset?: VST.Bridge.Asset;
}

export const returnAction: LoaderFunction = async ({
  params,
  request,
}): Promise<ReturnResult> => {
  if (params.vbid) {
    const formData = await request.formData();
    const hitDecimalOnly = formData.get("decimalOnly") === "true";

    try {
      // Do the return
      const bridgeResponse = hitDecimalOnly
        ? { status: 200, asset: undefined }
        : await bridgeReturnAsset(params.vbid);

      if (bridgeResponse.status === 200) {
        // Once it's returned, clear the license cache
        // Eventually the bridge call will go away and this endpoint will also process the return
        // See also placeholder bridge brand, which I'd also hope to be filled in by decimal
        await decimalReturnAsset(params.vbid);
        // Success/fail determined by the actual asset return status, not by the cache bust status
        return { ok: true, asset: bridgeResponse.asset };
      }
    } catch {
      // Fall through to default ok: false at the end
    }
  }

  return { ok: false };
};

export function useAssetReturnFetcher() {
  return useFetcher<ReturnResult>();
}
